<div class="terms-wrapper">
  <div class="container position-relative">
    <a (click)="goBack()" style="cursor: pointer;">
      <img src="assets/images/arrow_left_alt.svg" class="arrow" />
    </a>
    <h1 class="page-title ms-5">Terms & Conditions</h1>
  </div>

  <div class="intro-box">
    <p>
      Welcome to BeExpert, owned and operated by Acelucid Technologies
      Private Limited. By accessing or using BeExpert ("Platform",
      "Service"), you ("User", "Client") agree to the following Terms &
      Conditions. Please read them carefully.
    </p>
  </div>

  <h2 class="section-title">1. Introduction</h2>
  <p class="body-text">
    These Terms govern your use of BeExpert's AI-powered Learning management
    system, mentor sessions and AI Interview Preparation services. By using the
    platform, you accept these Terms in full.
  </p>

  <h2 class="section-title">2. Definitions</h2>

  <ul class="body-text">
    <li>
      <strong>Platform / Service:</strong> Digital services provided by BeExpert
       including mentoring sessions and AI-based interview preparation.
    </li>
    <li>
      <strong>User:</strong> Any person who accesses or uses the BeExpert
      platform.
    </li>
    <li>
      <strong>AI Output:</strong> Content generated through AI models integrated
      with the platform.
    </li>
    <li>
      <strong>OpenAI API:</strong> Third-party API used to generate AI outputs.
    </li>
    <li>
      <strong>User Data:</strong>Any information submitted on the platform by
      users.
    </li>
  </ul>

  <h2 class="section-title">3. Scope of Services</h2>
  <p class="body-text">BeExpert offers:</p>
  <ul class="body-text">
    <li>AI Powered Learning Management System</li>
    <li>One-on-one mentor sessions</li>
    <li>AI Interview Preparation sessions</li>
    <li>Digital guidance and feedback</li>
  </ul>

  <p class="body-text mt-2">Service availability depends on:</p>
  <ul class="body-text">
    <li>Internet connectivity</li>
    <li>Third-party systems (OpenAI, hosting partners, Razorpay)</li>
  </ul>

  <h2 class="section-title">4. Use of OpenAI & Data Handling</h2>
  <p class="body-text">
    BeExpert uses third-party AI APIs (OpenAI) to generate responses.
  </p>

  <p class="body-text">Key principles:</p>
  <ul class="body-text">
    <li>User data is processed securely</li>
    <li>OpenAI does not train on your data unless explicitly opted-in</li>
    <li>Data may be temporarily retained for abuse monitoring</li>
    <li>Sensitive information should not be submitted unless required</li>
    <li>
      Reference:
      <a
        href="https://openai.com/enterprise-privacy/"
        target="_blank"
        rel="noopener noreferrer"
        class="email-value"
      >
        OpenAI Enterprise Privacy Policy</a
      >
    </li>
  </ul>

  <h2 class="section-title">5. Usage of Google User Data</h2>
  <ul class="body-text">
    <li>
      We use your Google account information solely to allow you to securely
      sign in to BeExpert using Google OAuth. This helps us avoid storing
      your passwords on our servers.
    </li>
    <li>
      When you sign in with Google, we access limited profile information—such
      as your name, email address, and profile picture—to create or update your
      BeExpert account.This data is used only for identification and
      personalization inside the platform.We do not share this information with
      third parties.
    </li>

    <li>
      BeExpert does not read, store, or access your Gmail content, email
      metadata, or communication data in any form unless explicitly stated and
      consented for a feature (and currently no such feature exists).
    </li>
    <li>
      Only essential Google account identifiers (such as email ID and name) are
      securely stored to maintain your BeExpert account. We do not store
      OAuth tokens beyond what is required for login continuity. All stored data
      is encrypted.
    </li>
    <li>
      BeExpert fully adheres to Google’s API Services User Data Policy,
      including the Limited Use policy, ensuring minimal, transparent, and
      secure use of your Google data.
    </li>
  </ul>

  <h2 class="section-title">6. User Responsibilities</h2>
  <p class="body-text">Users agree to:</p>
  <ul class="body-text">
    <li>Provide accurate information</li>
    <li>Not misuse or abuse the platform</li>
    <li>Not upload harmful, illegal, or sensitive data</li>
    <li>Maintain confidentiality of login credentials</li>
    <li>Verify AI-generated content before using it professionally</li>
  </ul>

  <h2 class="section-title">7. Intellectual Property</h2>
  <ul class="body-text">
    <li>
      The platform, design, code, and UI are the intellectual property of
      Acelucid Technologies.
    </li>
    <li>AI-generated content is licensed to the user for personal use.</li>
    <li>
      Users may not reverse-engineer, copy, or redistribute platform elements.
    </li>
  </ul>

  <h2 class="section-title">8. Payment Terms</h2>
  <ul class="body-text">
    <li>Payments are processed through Razorpay.</li>
    <li>Prices are listed in INR.</li>
    <li>Non-payment or chargebacks may result in suspension of services.</li>
  </ul>

  <h2 class="section-title">9. Service Limitations</h2>
  <ul class="body-text">
    <li>AI outputs may contain inaccuracies or biases.</li>
    <li>BeExpert does not provide any guarantee of 100% accuracy.</li>
    <li>
      Feedback and interview preparation are guidance tools, not employment
      guarantees.
    </li>
  </ul>

  <h2 class="section-title">10. Limitation of Liability</h2>
  <p class="body-text">BeExpert is not liable for:</p>
  <ul class="body-text">
    <li>Decisions made based on AI outputs</li>
    <li>Technical disruptions</li>
    <li>Third-party failures (OpenAI, Razorpay, hosting services)</li>
  </ul>
  <p class="body-text">
    Liability is limited to the amount paid in the last three months.
  </p>

  <h2 class="section-title">11. Termination</h2>
  <p class="body-text">BeExpert reserves the right to:</p>
  <ul class="body-text">
    <li>Terminate accounts violating policies</li>
    <li>Restrict platform access</li>
    <li>Modify or discontinue certain services</li>
  </ul>
  <p class="body-text">Users may terminate their accounts anytime.</p>

  <h2 class="section-title">12. Updates to Terms</h2>
  <p class="body-text">
    We may update these Terms periodically. Users will be notified of major
    changes.
  </p>

  <h2 class="section-title">13. Governing Law</h2>
  <p class="body-text">
    These Terms are governed by the laws of India. Disputes fall under the
    jurisdiction of the courts in [City, State].
  </p>

  <h2 class="section-title">14. Contact</h2>
  <ul>
    <li>Acelucid Technologies Private Limited</li>
    <li>
      <i class="bi bi-envelope"></i>
      Email : <span class="email-value">{{ email }} </span>
    </li>
  </ul>
</div>
